import * as React from 'react';
import styles from './ContentNavigator.module.css';

export const ContentNavigator = () => {
    return (
        <a className={styles.link} href='#mainContent'>
            <label htmlFor="skipToContent">Hoppa till innehållet</label>
        </a>
    )
}
